module.exports = __webpack_public_path__ + "static/media/sunflowers2.01c38779.jpg";